import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "list-page-stack"
};
const _hoisted_2 = {
  key: 0,
  class: "list-page-header"
};
const _hoisted_3 = {
  key: 1,
  class: "list-page-filters"
};
const _hoisted_4 = {
  class: "list-page-content"
};
export default {
  __name: 'ListPageShell',
  props: {
    fill: {
      type: Boolean,
      default: false
    },
    bare: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["list-page-shell", {
          'list-page-shell--fill': __props.fill,
          'list-page-shell--bare': __props.bare
        }])
      }, [_createElementVNode("div", _hoisted_1, [_ctx.$slots.header ? (_openBlock(), _createElementBlock("section", _hoisted_2, [_renderSlot(_ctx.$slots, "header")])) : _createCommentVNode("", true), _ctx.$slots.filters ? (_openBlock(), _createElementBlock("section", _hoisted_3, [_renderSlot(_ctx.$slots, "filters")])) : _createCommentVNode("", true), _createElementVNode("section", _hoisted_4, [_renderSlot(_ctx.$slots, "default")])])], 2);
    };
  }
};